import { equals } from "ramda";

import { RootState } from "src/app/model/store";
import { CareerType } from "src/shared/config";

export const selectCareers = (state: RootState) => {
  return state.careers.careers;
};

export const selectNewCareer = (state: RootState) => {
  return state.careers.newCareer;
};

export const selectCareerByID = (state: RootState, id: CareerType["id"]) => {
  return state.careers.careers.find((career) => equals(career.id, id));
};
